import withSort from '../../../../elements/HOC/withSort'
import withSpinning from '../../../../elements/HOC/withSpinning'
import CustomSelect from '../../../../elements/Select/CustomSelect'
import withData from '../../../../elements/Select/withData'
import withSelectFetch from '../../../../elements/Select/withSelectFetch'
import { dateVal } from '../../../../modules/Utils'
import moment from 'moment'
import React from 'react'
import { Checkbox, Col, DatePicker, Form, Input, Row, TimePicker } from 'antd'
import { get, isEmpty } from 'lodash'
import { rules } from '../../../../modules/FormItems'
import { defaultFormItemLayout } from '../../../../modules/FormItems'
import { fullWidthFormItemLayout } from '../../../../modules/FormItems'
import { compose } from 'recompose'
import FormSectionTitle from '../../../../elements/FormSectionTitle'
import useFetchSelectUrl from '../../../../elements/Hooks/useFetchSelectUrl'

const { TextArea } = Input

const TypeSelect = compose(
  withData({
    data: [
      { key: 'Comment', value: 'Comment' },
      { key: 'Data', value: 'Data' },
      { key: 'Attachment', value: 'Attachment' },
      { key: 'Todo', value: 'Todo' },
    ],
  }),
  withSort
)(CustomSelect)

const ActivityListSelect = compose(
  withData({
    data: [
      { key: 'Pending', value: 'Pending' },
      { key: 'Urgent', value: 'Urgent' },
      { key: 'Hold', value: 'Hold' },
      { key: 'Closed', value: 'Closed' },
    ],
  })
)(CustomSelect)

const TimezoneSelect = compose(
  withSelectFetch({
    dropdown: 'general',
    name: 'timezones',
  }),
  withSpinning,
  withSort
)(CustomSelect)

function TaskSystemLinesForm(props) {
  const { line, task } = props
  const { getFieldDecorator, setFieldsValue } = props.form

  const group = get(task, 'group._id')
  const [EmployeesSelect] = useFetchSelectUrl(
    {
      name: 'employees',
      url: `groups/${group.replace('groups', '')}/links`,
      cache: false,
    },
    [group],
    isEmpty(group),
    undefined,
    (group) => ({
      ...group,
      display: `${group.code} - ${group.title}`,
    })
  )

  return (
    <Form>
      {/*<Row>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label={'Type'}>
            {getFieldDecorator('type', {
              initialValue: get(line, 'state'),
              rules: rules.select,
            })(<TypeSelect placeholder={'type'} />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Date">
            {getFieldDecorator('date', {
              initialValue: dateVal(line, 'date') || moment(),
              rules: rules.select,
            })(<DatePicker style={{width: '100%'}} />)}
          </Form.Item>
        </Col>
      </Row>*/}
      <Row>
        <Col span={3}>
          <Form.Item {...defaultFormItemLayout} label="No">
            {getFieldDecorator('no', {
              initialValue: get(line, 'no'),
              rules: rules.select,
            })(<Input placeholder={'no'} />)}
          </Form.Item>
        </Col>
        <Col span={21}>
          <Form.Item {...fullWidthFormItemLayout} label="Title">
            {getFieldDecorator('title', {
              initialValue: get(line, 'title'),
              rules: rules.select,
            })(<Input placeholder={'Title'} />)}
          </Form.Item>
        </Col>

        <Col span={24}>
          <Form.Item {...fullWidthFormItemLayout} label="Activity">
            {getFieldDecorator('description', {
              initialValue: get(line, 'description'),
            })(<TextArea rows={7} />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Complete By">
            {getFieldDecorator('due.date', {
              initialValue: dateVal(line, 'due.date'),
              //rules: rules.select,
            })(
              <DatePicker
                style={{ width: '100%' }}
                onChange={(value) => {
                  if (value) {
                    const newV = moment(value.format()).subtract(3, 'days')
                    setFieldsValue({ followupDate: newV })
                  }
                }}
              />
            )}
            {getFieldDecorator('due.time', {
              initialValue: dateVal(line, 'start.time'),
            })(<TimePicker defaultOpenValue={moment('00:00:00', 'HH:mm:ss')} />)}
            {getFieldDecorator('due.timezone', {
              initialValue: get(line, 'start.timezone'),
            })(<TimezoneSelect placeholder={'Select a timezone'} keyAtr={'text'} valueAtr={'text'} />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Assigned To">
            {getFieldDecorator('assignedTo._id', {
              initialValue: get(line, 'assignedTo._id'),
            })(<EmployeesSelect placeholder={'Select a Employee'} keyAtr={'member._id'} valueAtr={'member.fn'} />)}
          </Form.Item>
        </Col>

        <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="Status">
            {getFieldDecorator('status', {
              initialValue: get(line, 'status') || 'Pending',
              rules: rules.select,
            })(<ActivityListSelect />)}
          </Form.Item>
          <Form.Item {...defaultFormItemLayout} label="Send Notification" style={{ fontWeight: 'bold', color: 'red' }}>
            {getFieldDecorator('sendEmail', {
              valuePropName: 'checked',
            })(<Checkbox />)}
          </Form.Item>
        </Col>
        {/*<FormSectionTitle title={'TRACK TIME'} />*/}
        {/* <Col span={12}>
          <Form.Item {...defaultFormItemLayout} label="End">
            {getFieldDecorator('end.date', {
              initialValue: dateVal(line, 'end.date'),
              //rules: rules.select,
            })(
              <DatePicker
                style={{width: '100%'}}
                onChange={value => {
                  if (value) {
                    const newV = moment(value.format()).subtract(3, 'days')
                    setFieldsValue({followupDate: newV})
                  }
                }}
              />,
            )}
            {getFieldDecorator('end.time', {
              initialValue: dateVal(line, 'end.time'),
            })(
              <TimePicker defaultOpenValue={moment('00:00:00', 'HH:mm:ss')} />,
            )}
            {getFieldDecorator('end.timezone', {
              initialValue: get(line, 'end.timezone'),
            })(
              <TimezoneSelect
                placeholder={'Select a timezone'}
                keyAtr={'text'}
                valueAtr={'text'}
              />,
            )}
          </Form.Item>
        </Col>*/}
      </Row>
    </Form>
  )
}

TaskSystemLinesForm.propTypes = {}
TaskSystemLinesForm.defaultProps = {}

export default Form.create()(TaskSystemLinesForm)
